module.exports = __webpack_public_path__ + "img/Bereitstellungsrau_mit_Meldekopf.62f475ce.svg";